import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Form, InputForm, Validation } from "../../components/Form";
import { Autocomplete } from "../../components/Autocomplete";
import { BasePaper, Row } from "../../components/Base";
import Button from "../../components/Button";
import { getObservable, createObservable, updateObservable } from "../../api/observable";

const testTypes = ["assessment", "check"];

const areas = ["dangerous good", "other"];

const statusAll = ["active", "passive"];

const EditObservable = ({ match, history }) => {
  const { t } = useTranslation();
  const { observableId } = match.params;
  const isAdd = !observableId;
  const [observable, setObservableRes] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [selectedTestType, setSelectedTestType] = useState(null);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    (async () => {
      if (observableId) {
        const observableRes = await getObservable(observableId);
        setObservableRes(observableRes);
        setSelectedTestType(observableRes.test_type);
        setSelectedArea(observableRes.area);
        setSelectedStatus(observableRes.status);
      }
      setLoaded(true);
    })();
  }, [observableId]);

  const goBack = () => history.goBack();

  const onSubmit = async (values) => {
    let result;

    values.test_type = selectedTestType;
    values.area = selectedArea;
    values.status = selectedStatus;

    if (isAdd) {
      result = await createObservable(values);
    } else {
      result = await updateObservable(observableId, values);
    }
    if (result.ok) {
      history.push("/observable");
    }
  };

  const title = isAdd ? t("observable.add_title") : t("observable.edit_title");

  return (
    <>
      <Typography variant="h4">
        <Button icon={<ArrowBackIcon />} onClick={goBack} />
        {title}
      </Typography>
      {loaded ? (
        <BasePaper>
          <Form
            defaultValues={{
              name: observable?.name,
            }}
            validation={{
              name: Validation.required,
            }}
            onSubmit={onSubmit}
          >
            <Row>
              <InputForm name="name" label={t("observable.name_required")} />
            </Row>

            <Row>
              <Autocomplete
                label={t("observable.test_type")}
                options={testTypes}
                value={selectedTestType}
                onChange={(items) => {
                  setSelectedTestType(items);
                }}
                getOptionLabel={(item) => `${item}`}
              />
            </Row>

            <Row>
              <Autocomplete
                label={t("observable.area")}
                options={areas}
                value={selectedArea}
                onChange={(items) => {
                  setSelectedArea(items);
                }}
                getOptionLabel={(item) => `${item}`}
              />
            </Row>

            <Row>
              <Autocomplete
                label={t("status")}
                options={statusAll}
                value={selectedStatus}
                onChange={(items) => {
                  setSelectedStatus(items);
                }}
                getOptionLabel={(item) => `${item}`}
              />
            </Row>

            <Row>
              <Button type="submit">{t("save")}</Button>
              <Button onClick={goBack}>{t("cancel")}</Button>
            </Row>
          </Form>
        </BasePaper>
      ) : null}
    </>
  );
};

export default EditObservable;
